// src/pages/SendMoneyTab.js
import React from "react";
import Sendmoneyflow from "./Sendmoneyflow";
import { useLocation, useNavigate } from "react-router-dom";

function SendMoneyTab() {
  const location = useLocation();
  const navigate = useNavigate();
  const paramsdata = location.state || {};


  // Below functionality for Two-Factor authenticator

     var two_fa = sessionStorage.getItem('two_fa');
    var qr_enabled = sessionStorage.getItem('qr_enabled');
    var qr_login_completed = sessionStorage.getItem('qr_login_completed');
    // console.log("paramsdata:", paramsdata);
    // console.log("qr_login_completed:", qr_login_completed);
    if (!Object.prototype.hasOwnProperty.call(paramsdata, 'qr_login_completed')) {
      navigate('/business');
    }
    if (two_fa == 1 && qr_enabled == 0) {
      navigate('/business');
    } else if (two_fa == 1 && qr_enabled == 1) {
      if (qr_login_completed == 1 || paramsdata.qr_login_completed == 1) {
        console.log("success");
      } else {
        navigate('/business');
      }
    }


  return (
    <div className="w-full min-h-screen bg-[#F9FAFB] px-6 py-4">
      <Sendmoneyflow />
      
    </div>
  );
}

export default SendMoneyTab;